import React, { useEffect, useState } from "react";
import { Box, Checkbox, Grid2, IconButton, ListItemText, MenuItem, Select, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { headingStyles,defaultButtonStyles } from "../../assets/styles/CommonStyles";
import CustomInvoiceTable from "../../components/dataTable/CustomInvoiceTable";
import { AppLayout, ArrowBackIosIcon, CustomButton, CustomConfirmDialog, DeleteIcon, useLocation, useNavigate } from "../../utils/globalImports";
 import { validationMessages,Toaster } from "../../utils/globalImports";
import { invoiceTypes } from "./InvoiceTypesMapping";
import MoreVertIcon from '@mui/icons-material/MoreVert';


const SelectInvoiceType: React.FC<any> = ({}) => {
const location = useLocation();
const navigate = useNavigate();
const [selectedRow, setSelectedRow] = useState<any[]>(
  location.state?.selectedRow || []
);
const [deleteProjectId, setDeleteProjectId] = useState<number | null>(null);
 
 const [selectedInvoiceTypes, setSelectedInvoiceTypes] = useState<
  {[key: number]: number[] }[]
>([]);
useEffect(() => {
  if (!selectedRow || selectedRow.length === 0) {
    navigate("/invoicing");
  }
}, [selectedRow]);
const [toast, setToast] = useState({ open: false, message: "", type: "success" as "success" | "error" | "warning" });
 const handleInvoiceTypeChange = (projectId: number, value: number[]) => {

  setSelectedInvoiceTypes((prev) => {

    const index = prev.findIndex(obj => Object.keys(obj)[0] === projectId.toString());

    if (index !== -1) {
      const updated = [...prev];
      updated[index] = { [projectId]: value };
      return updated;
    }

    return [...prev, { [projectId]: value }];
  });

};
  const [dialogOpen,setDialogOpen]=useState<boolean>(false)
 const handleDeleteState=(projectId:number)=>{
    setDeleteProjectId(projectId);
    setDialogOpen(true);
    
 }
 const handleConfirm = () => {
  if (deleteProjectId !== null) {
    setSelectedRow(prev =>
      prev.filter(project => project.projectId !== deleteProjectId)
    );
  }

  setDialogOpen(false);
  setDeleteProjectId(null);
};

const handleCancel = () => {
  setDialogOpen(false);
  setDeleteProjectId(null);
};
 
  const columns: GridColDef[] = [
    { field: "projectNo", headerName: "Project No.", flex: 0.75 },
    { field: "projectName", headerName: "Project Name", flex: 1 },
    { field: "budgetRemaining", headerName: "Budget Remaining", flex: 0.75 },
    { field: "afpBalance", headerName: "AFP Balance", flex: 0.75 },
    { field: "wipBalance", headerName: "WIP Balance", flex: 0.75 },
     { field: "preBillBalance", headerName: "PreBill Balance", flex: 0.75 },


    {
      field: "invoiceTypes",
      headerName: "Invoice Types",
      flex: 1.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
      const projectId = params.row.projectId;
      const obj = selectedInvoiceTypes.find(
      o => Object.keys(o)[0] === projectId.toString()
  );

  const selectedValues = obj ? obj[projectId] : [];

  return (
    <Select
      multiple
      size="small"
      value={selectedValues}
      onChange={(e) =>
        handleInvoiceTypeChange(projectId, e.target.value as number[])
      }
      sx={{ width: "80%" }}
      renderValue={(selected) =>
        invoiceTypes
          .filter((type) => selected.includes(type.id))
          .map((type) => type.label)
          .join(", ")
      }
    >
      {invoiceTypes.map((type) => (
        <MenuItem key={type.id} value={type.id}>
          
          <Checkbox
                        checked={selectedValues.includes(type.id)}
                        sx={{
                          color: "rgba(150, 193, 33, 0.75) !important",
                          "&.Mui-checked": {
                            color: "rgba(150, 193, 33, 0.75) !important",
                          },
                          "& .MuiSvgIcon-root": {
                            fontSize: "18px",
                            backgroundColor: "rgba(169, 201, 81, 0.12)",
                            borderRadius: "4px",
                          },
                        }}
                      />
          <ListItemText primary={type.label} />
        </MenuItem>
      ))}
    </Select>

        );
      },
    },
    {
      field:"delete",
      headerName:"",
      flex:0.2,
      sortable:false,
      filterable:false,
      renderCell(params) {
        return(
          <>
        <IconButton
        
        onClick={() => handleDeleteState(params.row.projectId)}
      >
        <DeleteIcon sx={{color:'rgba(150, 193, 33, 0.75)'}}></DeleteIcon>
        </IconButton>
          </>
        )
      },

    }
    
  ];
 

 const handleNavigate=()=>{
    navigate("/invoicing")
 }
  const handleValidation=()=>{
    const isValid = selectedRow.every((project: any) => {
    const obj = selectedInvoiceTypes.find(
      o => Object.keys(o)[0] === project.projectId.toString()
    );
    
    return obj && obj[project.projectId].length > 0;
  });

  if (!isValid) {
    setToast({
      open: true,
      message: validationMessages.Invoice_ProjectInvoiceTypesNotSelected,
      type: "error"
    });
    return;
    
  }
  else{
       navigate("/invoicing/create-invoice",{
         state: {selectedInvoiceTypes}
       })
 }
 
 
  }
  //selecting the only required Feilds
const filteredProjects = selectedRow.map((data:any)=> ({
  projectId:data.projectId,
  projectNo: data.projectNo,
  projectName: data.projectName,
  budgetRemaining:data.budgetRemaining,
  afpBalance:data.afpBalance,
  wipBalance:data.wipBalance,
  preBillBalance:data.preBillBalance

}));
  return (
    <AppLayout>
    <Box sx={{display:'flex',flexDirection:'column',gap:'20px'}}>
        <Grid2 size={{ xs: 12, md: 6, lg: 6 }} sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton sx={{ width: '40px', height: '40px', backgroundColor: 'transparent' }} onClick={() => handleNavigate()} >
                        <ArrowBackIosIcon sx={{ color: '#1e66ab', fontSize: '15px', fontWeight: 500 }} />
                    </IconButton>
                    <Typography sx={headingStyles}>
                        Select Invoice Types
                    </Typography>
        </Grid2>
      <CustomInvoiceTable
        rows={filteredProjects}
        columns={columns}
       
        gridHeight="auto"
         checkBox={false}
      />
      <Box >
        <Grid2 sx={{display:'flex',justifyContent:'flex-end'}}>
            <CustomButton style={{width:'200px'}} sx={defaultButtonStyles} onClick={handleValidation}>Next</CustomButton>
             
        </Grid2>
        
      </Box>
      <Toaster open={toast.open} message={toast.message} type={toast.type as "success" | "error" | "warning"} onClose={() => setToast({ ...toast, open: false })} />
    </Box>
    <CustomConfirmDialog
                    open={dialogOpen}
                    title="Confirm Remove"
                    message="Are you sure you want to Remove Project?"
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    onClose={handleCancel}
                />
    </AppLayout>
  );
};

export default SelectInvoiceType;
